import { useState, useEffect } from 'react';
import Footer from './Footer';
import Header from './Header';

export default function FabrilifePage() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [activeCategory, setActiveCategory] = useState(null);
  const [expandedCategories, setExpandedCategories] = useState({});

  // ── Polo Section State (API-ready) ─────────────────────────────────────────
  const [poloSectionTitle, setPoloSectionTitle] = useState(null);
  const [poloProducts, setPoloProducts] = useState([]);
  const [poloLoading, setPoloLoading] = useState(true);

  useEffect(() => {
    const fetchPoloProducts = async () => {
      setPoloLoading(true);
      try {
        // TODO: Replace with real API call later, e.g.:
        // const res = await fetch('/api/sections/designer-polo');
        // const data = await res.json();
        // setPoloSectionTitle(data.sectionTitle);
        // setPoloProducts(data.products);

        // Static fallback — mirrors document 1 HTML exactly
        const data = {
          sectionTitle: {
            label: 'Designer Polo',
            url: '/shop?refinementList%5Bcats%5D%5B0%5D=Mens%20%3E%20Polo%20T-shirt',
            image: 'https://fabrilife.com/image-gallery/67c4f8805a51e-square.jpg',
          },
          products: [
            {
              id: 71905,
              name: 'Single Jersey Knitted Cotton Polo - Black',
              image: 'https://fabrilife.com/products/6217845392680-square.jpg',
              url: '/product/71905-single-jersey-knitted-cotton-polo-black',
              price: 750.00,
              originalPrice: 980.00,
              viewMore: false,
            },
            {
              id: 72123,
              name: 'Premium Double PK Cotton Polo - Navy',
              image: 'https://fabrilife.com/products/64afac03ba8fc-square.jpg',
              url: '/product/72123-premium-double-pk-cotton-polo-navy',
              price: 1090.00,
              originalPrice: 1290.00,
              viewMore: false,
            },
            {
              id: 72117,
              name: 'Premium Double PK Cotton Polo - Green',
              image: 'https://fabrilife.com/products/68f0c467190b7-square.jpg',
              url: '/product/72117-premium-double-pk-cotton-polo-green',
              price: 1090.00,
              originalPrice: 1290.00,
              viewMore: false,
            },
            {
              id: 72056,
              name: 'Single Jersey Knitted Cotton Polo - Stellar',
              image: 'https://fabrilife.com/products/62c3cc3bab060-square.jpg',
              url: '/product/72056-single-jersey-knitted-cotton-polo-stellar',
              price: 750.00,
              originalPrice: 980.00,
              viewMore: false,
            },
            {
              id: 72866,
              name: 'Premium Double PK Cotton Polo - Coffee Quartz',
              image: 'https://fabrilife.com/products/65c4df8442aa5-square.jpg',
              url: '/product/72866-premium-double-pk-cotton-polo-coffee-quartz',
              price: 1090.00,
              originalPrice: 1290.00,
              viewMore: false,
            },
            {
              id: 73073,
              name: 'Premium Designer Edition Double PK Cotton Polo - Spectrum',
              image: 'https://fabrilife.com/products/66e2e8eece105-square.jpg',
              url: '/product/73073-premium-designer-edition-double-pk-cotton-polo-spectrum',
              price: 1140.00,
              originalPrice: 1490.00,
              viewMore: false,
            },
            {
              id: 73449,
              name: 'Premium Designer Edition Double PK Cotton Polo - Icon',
              image: 'https://fabrilife.com/products/6863d4366b619-square.jpg',
              url: '/product/73449-premium-designer-edition-double-pk-cotton-polo-icon',
              price: 1260.00,
              originalPrice: 1600.00,
              viewMore: false,
            },
            {
              id: 71910,
              name: 'Single Jersey Knitted Cotton Polo - Navy',
              image: 'https://fabrilife.com/products/62178453aa564-square.jpg',
              url: '/product/71910-single-jersey-knitted-cotton-polo-navy',
              price: 750.00,
              originalPrice: 980.00,
              viewMore: true,
              viewMoreUrl: '/shop?refinementList%5Bcats%5D%5B0%5D=Mens%20%3E%20Polo%20T-shirt',
            },
          ],
        };

        setPoloSectionTitle(data.sectionTitle);
        setPoloProducts(data.products);
      } catch (error) {
        console.error('Failed to fetch polo products:', error);
      } finally {
        setPoloLoading(false);
      }
    };

    fetchPoloProducts();
  }, []);
  // ──────────────────────────────────────────────────────────────────────────

  useEffect(() => {
    // Handle window resize
    const handleResize = () => {
      if (window.innerWidth > 768) {
        setMobileMenuOpen(false);
      }
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const toggleCategory = (categoryId) => {
    setExpandedCategories(prev => ({
      ...prev,
      [categoryId]: !prev[categoryId]
    }));
  };

  const menCategories = [
    {
      title: 'Topwear',
      items: [
        { name: 'Half Sleeve T-shirt', url: '/shop?refinementList%5Bcats%5D%5B0%5D=Mens%20%3E%20Half%20Sleeve%20T-shirt' },
        { name: 'Full Sleeve T-shirt', url: '/shop?refinementList%5Bcats%5D%5B0%5D=Mens%20%3E%20Full%20Sleeve%20T-shirt' },
        { name: 'Polo T-shirt', url: '/shop?refinementList%5Bcats%5D%5B0%5D=Mens%20%3E%20Polo%20T-shirt' },
        { name: 'Shirt', url: '/shop?refinementList%5Bcats%5D%5B0%5D=Mens%20%3E%20Shirt' },
        { name: 'Panjabi', url: '/shop?refinementList%5Bcats%5D%5B0%5D=Mens%20%3E%20Panjabi' },
        { name: 'Hoodie', url: '/shop?refinementList%5Bcats%5D%5B0%5D=Mens%20%3E%20Hoodie' },
        { name: 'Jacket', url: '/shop?refinementList%5Bcats%5D%5B0%5D=Mens%20%3E%20Jacket' },
        { name: 'Sweatshirt', url: '/shop?refinementList%5Bcats%5D%5B0%5D=Mens%20%3E%20Sweatshirt' }
      ]
    },
    {
      title: 'Bottomwear',
      items: [
        { name: 'Comfy Trouser', url: '/shop?refinementList%5Bcats%5D%5B0%5D=Mens%20%3E%20Comfy%20Trouser' },
        { name: 'Sports Trouser', url: '/shop?refinementList%5Bcats%5D%5B0%5D=Mens%20%3E%20Sports%20Trouser' },
        { name: 'Jeans', url: '/shop?refinementList%5Bcats%5D%5B0%5D=Mens%20%3E%20Jeans' },
        { name: 'Joggers', url: '/shop?refinementList%5Bcats%5D%5B0%5D=Mens%20%3E%20Joggers' },
        { name: 'Cargo Pants', url: '/shop?refinementList%5Bcats%5D%5B0%5D=Mens%20%3E%20Cargo%20Pants' },
        { name: 'Chino Pants', url: '/shop?refinementList%5Bcats%5D%5B0%5D=Mens%20%3E%20Chino%20Pants' },
        { name: 'Shorts', url: '/shop?refinementList%5Bcats%5D%5B0%5D=Mens%20%3E%20Shorts' },
        { name: 'Pajama', url: '/shop?refinementList%5Bcats%5D%5B0%5D=Mens%20%3E%20Pajama' }
      ]
    },
    {
      title: 'Accessories',
      items: [
        { name: 'Face Mask', url: '/shop?refinementList%5Bcats%5D%5B0%5D=Face%20Mask' },
        { name: 'Underwear', url: '/shop?refinementList%5Bcats%5D%5B0%5D=Mens%20%3E%20Underwear' },
        { name: 'Socks', url: '/shop?refinementList%5Bcats%5D%5B0%5D=Mens%20%3E%20Socks' },
        { name: 'Wallet', url: '/shop?refinementList%5Bcats%5D%5B0%5D=Mens%20%3E%20Accesorries%20%3E%20Wallet' },
        { name: 'Cap', url: '/shop?refinementList%5Bcats%5D%5B0%5D=Mens%20%3E%20Accesorries%20%3E%20Cap' },
        { name: 'Belt', url: '/shop?refinementList%5Bcats%5D%5B0%5D=Mens%20%3E%20Accesorries%20%3E%20Belt' }
      ]
    }
  ];

  const womenCategories = [
    {
      title: 'Western & Ethnic',
      items: [
        { name: 'Kurti Tunic And Tops', url: '/shop?refinementList%5Bcats%5D%5B0%5D=Womens%20%3E%20Kurti%20Tunic%20And%20Tops' },
        { name: 'T-Shirt', url: '/shop?refinementList%5Bcats%5D%5B0%5D=Womens%20%3E%20T-Shirt' },
        { name: 'Comfy Trouser', url: '/shop?refinementList%5Bcats%5D%5B0%5D=Womens%20%3E%20Comfy%20Trouser' },
        { name: 'Pajamas', url: '/shop?refinementList%5Bcats%5D%5B0%5D=Womens%20%3E%20Pajamas' },
        { name: 'Co-ords', url: '/shop?refinementList%5Bcats%5D%5B0%5D=Womens%20%3E%20Co-ords' },
        { name: 'Shrug', url: '/shop?refinementList%5Bcats%5D%5B0%5D=Womens%20%3E%20Shrug' },
        { name: 'Palazzo', url: '/shop?refinementList%5Bcats%5D%5B0%5D=Womens%20%3E%20Palazzo' },
        { name: 'Pants', url: '/shop?refinementList%5Bcats%5D%5B0%5D=Womens%20%3E%20Pants' },
        { name: 'Leggings', url: '/shop?refinementList%5Bcats%5D%5B0%5D=Womens%20%3E%20Leggings' },
        { name: '3pc Salwar Kameez', url: '/shop?refinementList%5Bcats%5D%5B0%5D=Womens%20%3E%203pc%20Salwar%20Kameez' }
      ]
    }
  ];

  const kidsCategories = [
    {
      title: 'Boys',
      items: [
        { name: 'Half Sleeve T-shirt', url: '/shop?refinementList%5Bcats%5D%5B0%5D=Kids%20%3E%20Boys%20%3E%20Half%20Sleeve%20T-shirt' },
        { name: 'Full Sleeve T-shirt', url: '/shop?refinementList%5Bcats%5D%5B0%5D=Kids%20%3E%20Boys%20%3E%20Full%20Sleeve%20T-shirt' },
        { name: 'Trouser', url: '/shop?refinementList%5Bcats%5D%5B0%5D=Kids%20%3E%20Boys%20%3E%20Trouser' },
        { name: 'Shorts', url: '/shop?refinementList%5Bcats%5D%5B0%5D=Kids%20%3E%20Boys%20%3E%20Shorts' }
      ]
    },
    {
      title: 'Girls',
      items: [
        { name: 'T-shirt', url: '/shop?refinementList%5Bcats%5D%5B0%5D=Kids%20%3E%20Girls%20%3E%20T-shirt' },
        { name: 'Trouser', url: '/shop?refinementList%5Bcats%5D%5B0%5D=Kids%20%3E%20Girls%20%3E%20Trouser' },
        { name: 'Shorts', url: '/shop?refinementList%5Bcats%5D%5B0%5D=Kids%20%3E%20Girls%20%3E%20shorts' }
      ]
    }
  ];

  const newArrivals = [
    {
      title: 'Mens Premium Chino Pant - Mantrim',
      image: 'https://fabrilife.com/image-gallery/697eddd27f672-square.jpg',
      url: '/product/73869-mens-premium-chino-pant-mantrim'
    },
    {
      title: 'Mens Premium Formal Shirt - Skynet',
      image: 'https://fabrilife.com/image-gallery/697f51562d82b-square.jpg',
      url: '/product/73958-mens-premium-formal-shirt-skynet'
    },
    {
      title: 'Mens Premium Formal Shirt - Dyquard',
      image: 'https://fabrilife.com/image-gallery/697f51b4cd390.jpg',
      url: '/product/73957-mens-premium-formal-shirt-dyquard'
    },
    {
      title: 'Mens Premium Formal Shirt - Orchestra',
      image: 'https://fabrilife.com/image-gallery/697f50b343ced.jpg',
      url: '/product/73956-mens-premium-formal-shirt-orchestra'
    }
  ];

  const womenNewArrivals = [
    {
      title: 'Womens Premium Kurti - Elizarna',
      image: 'https://fabrilife.com/image-gallery/69722a3a15ee7-square.jpg',
      url: '/product/73947-womens-premium-kurti-elizarna'
    },
    {
      title: 'Women Premium Co-ords - Sandora',
      image: 'https://fabrilife.com/image-gallery/6963675399e21-square.jpg',
      url: '/product/73762-women-premium-co-ords-sandora'
    },
    {
      title: 'Women Premium Hoodie - Dazzelina',
      image: 'https://fabrilife.com/image-gallery/69660e9d1d1ed-square.jpg',
      url: '/product/73863-women-premium-hoodie-dazzelina'
    }
  ];

  const categoryProducts = [
    { name: 'Womens Comfy Trouser', image: 'https://fabrilife.com/image-gallery/61a794e1a66c7-square.jpg', url: '/shop?refinementList%5Bcats%5D%5B0%5D=Womens%20%3E%20Comfy%20Trouser' },
    { name: 'Kids Half Sleeve T-shirt', image: 'https://fabrilife.com/image-gallery/61a794e1a54c8-square.jpg', url: '/shop?refinementList%5Bcats%5D%5B0%5D=Kids%20%3E%20Boys%20%3E%20Half%20Sleeve%20T-shirt' },
    { name: 'Kids Full Sleeve T-shirt', image: 'https://fabrilife.com/image-gallery/61a794e1a5fec-square.jpg', url: '/shop?refinementList%5Bcats%5D%5B0%5D=Kids%20%3E%20Boys%20%3E%20Full%20Sleeve%20T-shirt' },
    { name: 'Kids Trousers', image: 'https://fabrilife.com/image-gallery/61a794e1a15bc-square.jpg', url: '/shop?refinementList%5Bcats%5D%5B0%5D=Kids%20%3E%20Boys%20%3E%20Trouser' },
    { name: 'Kids Shorts', image: 'https://fabrilife.com/image-gallery/61a794e1a33c0-square.jpg', url: '/shop?refinementList%5Bcats%5D%5B0%5D=Kids%20%3E%20Girls%20%3E%20shorts' },
    { name: 'Premium Cloth Masks', image: 'https://fabrilife.com/image-gallery/63889c77163fb-square.jpg', url: '/shop?refinementList%5Bcats%5D%5B0%5D=Face%20Mask%20%3E%20Professional%207%20Layer%20Mask' },
    { name: 'Designer Edition Masks', image: 'https://fabrilife.com/image-gallery/63889c771b9a0-square.jpg', url: '/shop?refinementList%5Bcats%5D%5B0%5D=Face%20Mask%20%3E%20Womens%20Embroidery%20Edition' },
    { name: 'Kids Edition Masks', image: 'https://fabrilife.com/image-gallery/63889c77196df-square.jpg', url: '/shop?refinementList%5Bcats%5D%5B0%5D=Face%20Mask%20%3E%20Kids%20Mask' },
    { name: 'Premium Antibacterial Socks', image: 'https://fabrilife.com/image-gallery/638741f4bcae5-square.jpg', url: '/shop?refinementList%5Bcats%5D%5B0%5D=Mens%20%3E%20Socks' },
    { name: 'Womens Comfy Trouser', image: 'https://fabrilife.com/image-gallery/61a794e1a66c7-square.jpg', url: '/shop?refinementList%5Bcats%5D%5B0%5D=Womens%20%3E%20Comfy%20Trouser' },
    { name: 'Kids Half Sleeve T-shirt', image: 'https://fabrilife.com/image-gallery/61a794e1a54c8-square.jpg', url: '/shop?refinementList%5Bcats%5D%5B0%5D=Kids%20%3E%20Boys%20%3E%20Half%20Sleeve%20T-shirt' },
    { name: 'Kids Full Sleeve T-shirt', image: 'https://fabrilife.com/image-gallery/61a794e1a5fec-square.jpg', url: '/shop?refinementList%5Bcats%5D%5B0%5D=Kids%20%3E%20Boys%20%3E%20Full%20Sleeve%20T-shirt' },
    { name: 'Kids Trousers', image: 'https://fabrilife.com/image-gallery/61a794e1a15bc-square.jpg', url: '/shop?refinementList%5Bcats%5D%5B0%5D=Kids%20%3E%20Boys%20%3E%20Trouser' },
    { name: 'Kids Shorts', image: 'https://fabrilife.com/image-gallery/61a794e1a33c0-square.jpg', url: '/shop?refinementList%5Bcats%5D%5B0%5D=Kids%20%3E%20Girls%20%3E%20shorts' },
    { name: 'Premium Cloth Masks', image: 'https://fabrilife.com/image-gallery/63889c77163fb-square.jpg', url: '/shop?refinementList%5Bcats%5D%5B0%5D=Face%20Mask%20%3E%20Professional%207%20Layer%20Mask' },
    { name: 'Designer Edition Masks', image: 'https://fabrilife.com/image-gallery/63889c771b9a0-square.jpg', url: '/shop?refinementList%5Bcats%5D%5B0%5D=Face%20Mask%20%3E%20Womens%20Embroidery%20Edition' },
    { name: 'Kids Edition Masks', image: 'https://fabrilife.com/image-gallery/63889c77196df-square.jpg', url: '/shop?refinementList%5Bcats%5D%5B0%5D=Face%20Mask%20%3E%20Kids%20Mask' },
    { name: 'Premium Antibacterial Socks', image: 'https://fabrilife.com/image-gallery/638741f4bcae5-square.jpg', url: '/shop?refinementList%5Bcats%5D%5B0%5D=Mens%20%3E%20Socks' },
    { name: 'Womens Comfy Trouser', image: 'https://fabrilife.com/image-gallery/61a794e1a66c7-square.jpg', url: '/shop?refinementList%5Bcats%5D%5B0%5D=Womens%20%3E%20Comfy%20Trouser' },
    { name: 'Kids Half Sleeve T-shirt', image: 'https://fabrilife.com/image-gallery/61a794e1a54c8-square.jpg', url: '/shop?refinementList%5Bcats%5D%5B0%5D=Kids%20%3E%20Boys%20%3E%20Half%20Sleeve%20T-shirt' },
    { name: 'Kids Full Sleeve T-shirt', image: 'https://fabrilife.com/image-gallery/61a794e1a5fec-square.jpg', url: '/shop?refinementList%5Bcats%5D%5B0%5D=Kids%20%3E%20Boys%20%3E%20Full%20Sleeve%20T-shirt' },
    { name: 'Kids Trousers', image: 'https://fabrilife.com/image-gallery/61a794e1a15bc-square.jpg', url: '/shop?refinementList%5Bcats%5D%5B0%5D=Kids%20%3E%20Boys%20%3E%20Trouser' },
    { name: 'Kids Shorts', image: 'https://fabrilife.com/image-gallery/61a794e1a33c0-square.jpg', url: '/shop?refinementList%5Bcats%5D%5B0%5D=Kids%20%3E%20Girls%20%3E%20shorts' },
    { name: 'Premium Cloth Masks', image: 'https://fabrilife.com/image-gallery/63889c77163fb-square.jpg', url: '/shop?refinementList%5Bcats%5D%5B0%5D=Face%20Mask%20%3E%20Professional%207%20Layer%20Mask' },
    { name: 'Designer Edition Masks', image: 'https://fabrilife.com/image-gallery/63889c771b9a0-square.jpg', url: '/shop?refinementList%5Bcats%5D%5B0%5D=Face%20Mask%20%3E%20Womens%20Embroidery%20Edition' },
    { name: 'Kids Edition Masks', image: 'https://fabrilife.com/image-gallery/63889c77196df-square.jpg', url: '/shop?refinementList%5Bcats%5D%5B0%5D=Face%20Mask%20%3E%20Kids%20Mask' },
    { name: 'Premium Antibacterial Socks', image: 'https://fabrilife.com/image-gallery/638741f4bcae5-square.jpg', url: '/shop?refinementList%5Bcats%5D%5B0%5D=Mens%20%3E%20Socks' },
    { name: 'Designer Edition Masks', image: 'https://fabrilife.com/image-gallery/63889c771b9a0-square.jpg', url: '/shop?refinementList%5Bcats%5D%5B0%5D=Face%20Mask%20%3E%20Womens%20Embroidery%20Edition' },
  ];

  const galleryImages = [
    { name: 'Noakhali Express', image: 'https://fabrilife.com/images/homepage/694ab1840b225-1766314331-50rw9uxdv7.jpg', url: '/noakhali-express' },
    { name: 'Noakhali Express', image: 'https://fabrilife.com/images/homepage/694ab1987a9a0-rajshahi.jpg', url: '/noakhali-express' }
  ];


  const catagories_products = [
    {
      id: 1,
      name: "Printed Short Sleeve",
      image: "https://fabrilife.com/image-gallery/67cc52c0ea29e-square.jpg",
      url: "/shop?refinementList%5Bcats%5D%5B0%5D=Mens%20%3E%20Half%20Sleeve%20T-shirt%20%3E%20Printed"
    },
    {
      id: 2,
      name: "Designer Edition",
      image: "https://fabrilife.com/image-gallery/638a77dc9c88d-square.jpg",
      url: "/shop?refinementList%5Bcats%5D%5B0%5D=Mens%20%3E%20Half%20Sleeve%20T-shirt%20%3E%20Cut%20%26%20Stitch%20%28Designer%20Edition%29&refinementList%5Bcats%5D%5B1%5D=Mens%20%3E%20Half%20Sleeve%20T-shirt%20%3E%20Cut%20%26%20Stitch"
    },
    {
      id: 3,
      name: "Short Sleeve Blanks",
      image: "https://fabrilife.com/image-gallery/638a77dce126d-square.jpg",
      url: "/shop?refinementList%5Bcats%5D%5B0%5D=Mens%20%3E%20Half%20Sleeve%20T-shirt%20%3E%20Blank"
    },
    {
      id: 1,
      name: "Printed Short Sleeve",
      image: "https://fabrilife.com/image-gallery/67cc52c0ea29e-square.jpg",
      url: "/shop?refinementList%5Bcats%5D%5B0%5D=Mens%20%3E%20Half%20Sleeve%20T-shirt%20%3E%20Printed"
    },
    {
      id: 2,
      name: "Designer Edition",
      image: "https://fabrilife.com/image-gallery/638a77dc9c88d-square.jpg",
      url: "/shop?refinementList%5Bcats%5D%5B0%5D=Mens%20%3E%20Half%20Sleeve%20T-shirt%20%3E%20Cut%20%26%20Stitch%20%28Designer%20Edition%29&refinementList%5Bcats%5D%5B1%5D=Mens%20%3E%20Half%20Sleeve%20T-shirt%20%3E%20Cut%20%26%20Stitch"
    },
    {
      id: 3,
      name: "Short Sleeve Blanks",
      image: "https://fabrilife.com/image-gallery/638a77dce126d-square.jpg",
      url: "/shop?refinementList%5Bcats%5D%5B0%5D=Mens%20%3E%20Half%20Sleeve%20T-shirt%20%3E%20Blank"
    }
  ];



  const second_catagories_products = [
    {
      id: 1,
      name: "Printed Short Sleeve",
      image: "https://fabrilife.com/image-gallery/67cc879b9411e-square.jpg",
      url: "/shop?refinementList%5Bcats%5D%5B0%5D=Mens%20%3E%20Half%20Sleeve%20T-shirt%20%3E%20Printed"
    },
    {
      id: 2,
      name: "Designer Edition",
      image: "https://fabrilife.com/image-gallery/67cc879b94f3a-square.jpg",
      url: "/shop?refinementList%5Bcats%5D%5B0%5D=Mens%20%3E%20Half%20Sleeve%20T-shirt%20%3E%20Cut%20%26%20Stitch%20%28Designer%20Edition%29&refinementList%5Bcats%5D%5B1%5D=Mens%20%3E%20Half%20Sleeve%20T-shirt%20%3E%20Cut%20%26%20Stitch"
    },
    {
      id: 3,
      name: "Short Sleeve Blanks",
      image: "https://fabrilife.com/image-gallery/67c4ecd0908bd-square.jpg",
      url: "/shop?refinementList%5Bcats%5D%5B0%5D=Mens%20%3E%20Half%20Sleeve%20T-shirt%20%3E%20Blank"
    },

  ];




  const third_catagories_products = [
    {
      id: 1,
      name: "Printed Short Sleeve",
      image: "https://fabrilife.com/image-gallery/67c51415305a6-square.jpg",
      url: "/shop?refinementList%5Bcats%5D%5B0%5D=Mens%20%3E%20Half%20Sleeve%20T-shirt%20%3E%20Printed"
    },
    {
      id: 2,
      name: "Designer Edition",
      image: "https://fabrilife.com/image-gallery/67cc87e4ecfe9-square.jpg",
      url: "/shop?refinementList%5Bcats%5D%5B0%5D=Mens%20%3E%20Half%20Sleeve%20T-shirt%20%3E%20Cut%20%26%20Stitch%20%28Designer%20Edition%29&refinementList%5Bcats%5D%5B1%5D=Mens%20%3E%20Half%20Sleeve%20T-shirt%20%3E%20Cut%20%26%20Stitch"
    },
    {
      id: 3,
      name: "Short Sleeve Blanks",
      image: "https://fabrilife.com/image-gallery/67cc87e4edca0-square.jpg",
      url: "/shop?refinementList%5Bcats%5D%5B0%5D=Mens%20%3E%20Half%20Sleeve%20T-shirt%20%3E%20Blank"
    },


    {
      id: 1,
      name: "Printed Short Sleeve",
      image: "https://fabrilife.com/image-gallery/67c4ecd0559f9-square.jpg",
      url: "/shop?refinementList%5Bcats%5D%5B0%5D=Mens%20%3E%20Half%20Sleeve%20T-shirt%20%3E%20Printed"
    },
    {
      id: 2,
      name: "Designer Edition",
      image: "https://fabrilife.com/image-gallery/67c4ecd079329-square.jpg",
      url: "/shop?refinementList%5Bcats%5D%5B0%5D=Mens%20%3E%20Half%20Sleeve%20T-shirt%20%3E%20Cut%20%26%20Stitch%20%28Designer%20Edition%29&refinementList%5Bcats%5D%5B1%5D=Mens%20%3E%20Half%20Sleeve%20T-shirt%20%3E%20Cut%20%26%20Stitch"
    },
    {
      id: 3,
      name: "Short Sleeve Blanks",
      image: "https://fabrilife.com/image-gallery/67c4ecd062800-square.jpg",
      url: "/shop?refinementList%5Bcats%5D%5B0%5D=Mens%20%3E%20Half%20Sleeve%20T-shirt%20%3E%20Blank"
    },

  ];



  return (
    <div className="min-h-screen bg-white font-['Assistant','-apple-system','BlinkMacSystemFont','Segoe_UI','Roboto','sans-serif']" style={{ marginTop: '60px' }}>



      {/* Main Content */}
      <main className="pt-0">
        {/* Hero Banner */}
        <div className="w-full">
          <a href="/shop">
            <picture>
              <source media="(max-width: 480px)" srcSet="https://fabrilife.com/image-gallery/69221af25175a.jpg" />
              <source media="(max-width: 900px)" srcSet="https://fabrilife.com/image-gallery/69221af25067e.jpg" />
              <source media="(max-width: 1200px)" srcSet="https://fabrilife.com/image-gallery/69221af255306.jpg" />
              <img src="https://fabrilife.com/image-gallery/69221af255306.jpg" alt="Fabrilife Home Top" className="w-full h-auto" />
            </picture>
          </a>
        </div>

        {/* Quick Links Menu */}
        <div className="bg-gradient-to-r from-gray-800 to-gray-900 text-white">
          <div className="max-w-[1400px] mx-auto px-4 py-3">
            <div className="flex items-center justify-between flex-wrap gap-4">
              <div className="flex items-center space-x-8">
                <a href="/shop" className="px-6 py-2 bg-white text-black font-bold transform -skew-x-12 hover:bg-gray-100 transition-colors">
                  <span className="block transform skew-x-12">SHOP NOW</span>
                </a>
                <a href="/shop?refinementList%5Bcats%5D%5B0%5D=Mens" className="hover:text-gray-300 transition-colors font-medium">MEN</a>
                <a href="/shop?refinementList%5Bcats%5D%5B0%5D=Womens" className="hover:text-gray-300 transition-colors font-medium">WOMEN</a>
                <a href="/shop?refinementList%5Bcats%5D%5B0%5D=Kids" className="hover:text-gray-300 transition-colors font-medium">KIDS</a>
              </div>

              <div className="flex items-center space-x-3 bg-yellow-500 text-black px-6 py-2 transform -skew-x-6">
                <div className="transform skew-x-6">
                  <div className="font-bold">GET 5% OFF ON APP</div>
                  <div className="flex items-center space-x-2 mt-1">
                    <a href="https://play.google.com/store/apps/details?id=fabrilife.os.webview&hl=en&gl=US">
                      <img src="https://fabrilife.com/img/newhome/playstorebadge.svg" alt="Playstore" className="h-6" />
                    </a>
                    <a href="https://apps.apple.com/app/fabrilife/id1672120838">
                      <img src="https://fabrilife.com/img/newhome/fabrilifeappstore.svg" alt="Appstore" className="h-6" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Corporate Banner */}
        <div className="bg-[#E0F7FA] text-black py-2">
          <div className="max-w-[1400px] mx-auto px-4">
            <a href="/corporate" className="block">
              <div className="flex items-center space-x-2">
                <strong>Event T-shirt</strong>
                <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" />
                </svg>
                <span className="text-sm">T-shirt/Clothing with your brand logo or design? We are delivering worldwide at unbeatable prices.</span>
                <strong className="text-sm">Click here</strong>
              </div>
            </a>
          </div>
        </div>




        {/* Category Grid */}
        <div className="max-w-[1400px] mx-auto px-4 py-8">
          <div class="mt-0 h-[85px] bg-[#fcf4e9]">
            <a
              class="block h-full"
              href="/shop?refinementList%5Bcats%5D%5B0%5D=New%20Arrival"
            >
              <div class="flex items-center justify-center h-full">
                <div class="text-black font-['Assistant'] text-base leading-6">
                  NEW ARRIVAL
                </div>
              </div>
            </a>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 xl:grid-cols-7 gap-4">
            {categoryProducts.map((product, idx) => (
              <div key={idx} className="group">
                <a href={product.url} className="block">
                  <div className="aspect-square overflow-hidden rounded-lg mb-2 bg-gray-100">
                    <img src={product.image} alt={product.name} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300" loading="lazy" />
                  </div>
                </a>
              </div>
            ))}
          </div>
        </div>

        {/* Gallery Section */}
        <div className="max-w-[1400px] mx-auto px-4 py-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {galleryImages.map((item, idx) => (
              <div key={idx} className="relative group overflow-hidden rounded-lg">
                <a href={item.url}>
                  <img src={item.image} alt={item.name} className="w-full h-auto group-hover:scale-105 transition-transform duration-300" loading="lazy" />
                  <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black to-transparent p-6">
                    <div className="text-white text-xl font-bold">{item.name}</div>
                  </div>
                </a>
              </div>
            ))}
          </div>
        </div>

        {/* Featured Category Products */}

        <div className="w-full max-w-[1370px] mx-auto overflow-x-hidden overflow-y-clip">
          <div className="flex flex-wrap -mx-[15px]">
            {catagories_products.map((product) => (
              <div key={product.id} className="w-full sm:w-1/2 lg:w-1/3 px-[15px] mb-4">
                <a className="block" href={product.url}>
                  <div className="relative overflow-hidden">
                    <img
                      className="w-full h-auto object-cover transform hover:scale-105 transition-transform duration-300"
                      src={product.image}
                      alt={product.name}
                      loading="lazy"
                    />
                    <div
                      className="absolute bottom-0 left-0 right-0 text-center py-2"
                      style={{ fontFamily: "'Fjalla One', sans-serif", fontSize: '20.8px', color: '#000000', backgroundColor: 'rgba(255, 255, 255, 0.7)' }}
                    >
                      {product.name}
                    </div>
                  </div>
                </a>
              </div>
            ))}
          </div>


          <div>
            <div className="flex flex-col lg:flex-row">
              <div className="w-full lg:w-2/3">
                <div>
                  <div className="flex items-center">
                    <span style={{ fontFamily: "'Assistant', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif", fontSize: '40px', color: '#373A3C' }}>
                      Fabrilife
                    </span>
                    <i style={{ color: '#5cb85c', fontSize: '40px' }} className="fa fa-angle-right" aria-hidden="true"></i>
                  </div>
                  <div style={{ fontSize: '24px', color: '#373A3C' }} className="mt-2">
                    Because comfort and confidence go hand in hand.
                  </div>
                  <p style={{ fontSize: '16px', color: '#373A3C' }} className="mt-2">
                    We focus on carefully selecting the best clothing that is comfortable, looks great, and makes you confident.
                    Apart from the fabric, design and fit, we go through strict quality control parameters to give you what you truly deserve.
                    The power of a good outfit is how it can influence your perception of yourself.
                  </p>
                </div>
              </div>
              <div className="w-full lg:w-1/3 mt-4 lg:mt-0">
                <a href="sdf">
                  <img src="https://fabrilife.com/image-gallery/638b1d9333f59.pnggggg" className="w-full h-auto" />
                </a>
              </div>
            </div>
          </div>

          <div className="my-8 border-gray-300" />

          {/* ── Designer Polo Section — API-ready, placed after Fabrilife text block ── */}
          {/* Polo Section */}
          <div className="grid gap-[15px]"
            style={{
              gridTemplateColumns: '2fr repeat(4, 1fr)',
              gridTemplateRows: 'auto auto',
            }}>

            {/* Section title card — spans 2 rows, 1 column on the left */}
            {!poloLoading && poloSectionTitle && (
              <div style={{ gridColumn: '1', gridRow: '1 / 3' }}>
                <a href={poloSectionTitle.url}
                  className="flex flex-col h-full"
                  style={{ textDecoration: 'none' }}
                >
                  <div className="overflow-hidden rounded min-h-[200px]"
                    style={{ flex: 1 }}>
                    <img
                      src={poloSectionTitle.image}
                      alt={poloSectionTitle.label}
                      loading="lazy"
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                  <div className="text-center mt-2 text-sm font-semibold text-gray-800 flex-shrink-0">
                    {poloSectionTitle.label}
                  </div>
                </a>
              </div>
            )}

            {/* Product cards — 4 per row, filling columns 2–5 */}
            {poloProducts.map((product) => (
              <div key={product.id + '-' + product.name}>
                <a href={product.url} className="block group">
                  <div className="relative overflow-hidden rounded bg-gray-50">
                    <img
                      src={product.image}
                      alt={product.name}
                      loading="lazy"
                      className="w-full aspect-square object-cover group-hover:scale-105 transition-transform duration-300"
                    />

                    {/* Price tag — white bg, bottom center, inside image */}
                    <div className="absolute bottom-0 left-0 right-0 flex justify-center pb-1.5">
                      <div className="bg-white bg-opacity-95 rounded px-2 py-0.5 shadow-sm text-center leading-tight">
                        <strong className="text-gray-900 text-xs">৳ {product.price.toFixed(2)}</strong>{' '}
                        <s className="text-gray-400 text-[10px]">৳ {product.originalPrice.toFixed(2)}</s>
                      </div>
                    </div>

                    {product.viewMore && (
                      <div
                        onClick={(e) => { e.preventDefault(); window.location.href = product.viewMoreUrl; }}
                        className="absolute inset-0 flex flex-col items-center justify-center bg-black bg-opacity-40 text-white font-semibold text-sm gap-1 cursor-pointer"
                      >
                        <span>View</span>
                        <span>More</span>
                      </div>
                    )}
                  </div>
                  {/* No product name/title shown */}
                </a>
              </div>
            ))}

          </div>
          {/* ─────────────────────────────────────────────────────────────────────── */}

          <div className="my-8 border-gray-300" />




          <div className="grid gap-[15px]"
            style={{
              gridTemplateColumns: '2fr repeat(4, 1fr)',
              gridTemplateRows: 'auto auto',
            }}>

            {/* Section title card — spans 2 rows, 1 column on the left */}
            {!poloLoading && poloSectionTitle && (
              <div style={{ gridColumn: '1', gridRow: '1 / 3' }}>
                <a href={poloSectionTitle.url}
                  className="flex flex-col h-full"
                  style={{ textDecoration: 'none' }}
                >
                  <div className="overflow-hidden rounded min-h-[200px]"
                    style={{ flex: 1 }}>
                    <img
                      src={poloSectionTitle.image}
                      alt={poloSectionTitle.label}
                      loading="lazy"
                      className="w-full h-full object-cover object-top"
                    />
                  </div>


                  <div className="text-center mt-2 text-sm font-semibold text-gray-800 flex-shrink-0">
                    {poloSectionTitle.label}
                  </div>
                </a>
              </div>
            )}

            {/* Product cards — 4 per row, filling columns 2–5 */}
            {poloProducts.map((product) => (
              <div key={product.id + '-' + product.name}>
                <a href={product.url} className="block group">
                  <div className="relative overflow-hidden rounded bg-gray-50">
                    <img
                      src={product.image}
                      alt={product.name}
                      loading="lazy"
                      className="w-full aspect-square object-cover group-hover:scale-105 transition-transform duration-300"
                    />

                    {/* Price tag — white bg, bottom center, inside image */}
                    <div className="absolute bottom-0 left-0 right-0 flex justify-center pb-1.5">
                      <div className="bg-white bg-opacity-95 rounded px-2 py-0.5 shadow-sm text-center leading-tight">
                        <strong className="text-gray-900 text-xs">৳ {product.price.toFixed(2)}</strong>{' '}
                        <s className="text-gray-400 text-[10px]">৳ {product.originalPrice.toFixed(2)}</s>
                      </div>
                    </div>

                    {product.viewMore && (
                      <div
                        onClick={(e) => { e.preventDefault(); window.location.href = product.viewMoreUrl; }}
                        className="absolute inset-0 flex flex-col items-center justify-center bg-black bg-opacity-40 text-white font-semibold text-sm gap-1 cursor-pointer"
                      >
                        <span>View</span>
                        <span>More</span>
                      </div>
                    )}
                  </div>
                  {/* No product name/title shown */}
                </a>
              </div>
            ))}

          </div>


          <div className="my-8 border-gray-300" />


          {/* product catagory section */}


          <div className="w-full max-w-[1370px] mx-auto overflow-x-hidden overflow-y-clip">
            <div className="flex flex-wrap -mx-[15px]">
              {second_catagories_products.map((product) => (
                <div key={product.id} className="w-full sm:w-1/2 lg:w-1/3 px-[15px] mb-4">
                  <a className="block" href={product.url}>
                    <div className="relative overflow-hidden">
                      <img
                        className="w-full h-auto object-cover transform hover:scale-105 transition-transform duration-300"
                        src={product.image}
                        alt={product.name}
                        loading="lazy"
                      />
                      <div
                        className="absolute bottom-0 left-0 right-0 text-center py-2"
                        style={{ fontFamily: "'Fjalla One', sans-serif", fontSize: '20.8px', color: '#000000', backgroundColor: 'rgba(255, 255, 255, 0.7)' }}
                      >
                        {product.name}
                      </div>
                    </div>
                  </a>
                </div>
              ))}
            </div>
          </div>





          {/*Product Section*/}


          <div className="my-8 border-gray-300" />




          <div className="grid gap-[15px]"
            style={{
              gridTemplateColumns: '2fr repeat(4, 1fr)',
              gridTemplateRows: 'auto auto',
            }}>

            {/* Section title card — spans 2 rows, 1 column on the left */}
            {!poloLoading && poloSectionTitle && (
              <div style={{ gridColumn: '1', gridRow: '1 / 3' }}>
                <a href={poloSectionTitle.url}
                  className="flex flex-col h-full"
                  style={{ textDecoration: 'none' }}
                >
                  <div className="overflow-hidden rounded min-h-[200px]"
                    style={{ flex: 1 }}>
                    <img
                      src={poloSectionTitle.image}
                      alt={poloSectionTitle.label}
                      loading="lazy"
                      className="w-full h-full object-cover object-top"
                    />
                  </div>


                  <div className="text-center mt-2 text-sm font-semibold text-gray-800 flex-shrink-0">
                    {poloSectionTitle.label}
                  </div>
                </a>
              </div>
            )}

            {/* Product cards — 4 per row, filling columns 2–5 */}
            {poloProducts.map((product) => (
              <div key={product.id + '-' + product.name}>
                <a href={product.url} className="block group">
                  <div className="relative overflow-hidden rounded bg-gray-50">
                    <img
                      src={product.image}
                      alt={product.name}
                      loading="lazy"
                      className="w-full aspect-square object-cover group-hover:scale-105 transition-transform duration-300"
                    />

                    {/* Price tag — white bg, bottom center, inside image */}
                    <div className="absolute bottom-0 left-0 right-0 flex justify-center pb-1.5">
                      <div className="bg-white bg-opacity-95 rounded px-2 py-0.5 shadow-sm text-center leading-tight">
                        <strong className="text-gray-900 text-xs">৳ {product.price.toFixed(2)}</strong>{' '}
                        <s className="text-gray-400 text-[10px]">৳ {product.originalPrice.toFixed(2)}</s>
                      </div>
                    </div>

                    {product.viewMore && (
                      <div
                        onClick={(e) => { e.preventDefault(); window.location.href = product.viewMoreUrl; }}
                        className="absolute inset-0 flex flex-col items-center justify-center bg-black bg-opacity-40 text-white font-semibold text-sm gap-1 cursor-pointer"
                      >
                        <span>View</span>
                        <span>More</span>
                      </div>
                    )}
                  </div>
                  {/* No product name/title shown */}
                </a>
              </div>
            ))}

          </div>



          {/* product catagory section */}


          <div className="my-8 border-gray-300" />

          <div className="w-full max-w-[1370px] mx-auto overflow-x-hidden overflow-y-clip">
            <div className="flex flex-wrap -mx-[15px]">
              {third_catagories_products.map((product) => (
                <div key={product.id} className="w-full sm:w-1/2 lg:w-1/3 px-[15px] mb-4">
                  <a className="block" href={product.url}>
                    <div className="relative overflow-hidden">
                      <img
                        className="w-full h-auto object-cover transform hover:scale-105 transition-transform duration-300"
                        src={product.image}
                        alt={product.name}
                        loading="lazy"
                      />
                      <div
                        className="absolute bottom-0 left-0 right-0 text-center py-2"
                        style={{ fontFamily: "'Fjalla One', sans-serif", fontSize: '20.8px', color: '#000000', backgroundColor: 'rgba(255, 255, 255, 0.7)' }}
                      >
                        {product.name}
                      </div>
                    </div>
                  </a>
                </div>
              ))}
            </div>
          </div>





          {/*Product Section*/}

          <div className="my-8 border-gray-300" />

          <div className="grid gap-[15px]"
            style={{
              gridTemplateColumns: '2fr repeat(4, 1fr)',
              gridTemplateRows: 'auto auto',
            }}>

            {/* Section title card — spans 2 rows, 1 column on the left */}
            {!poloLoading && poloSectionTitle && (
              <div style={{ gridColumn: '1', gridRow: '1 / 3' }}>
                <a href={poloSectionTitle.url}
                  className="flex flex-col h-full"
                  style={{ textDecoration: 'none' }}
                >
                  <div className="overflow-hidden rounded min-h-[200px]"
                    style={{ flex: 1 }}>
                    <img
                      src={poloSectionTitle.image}
                      alt={poloSectionTitle.label}
                      loading="lazy"
                      className="w-full h-full object-cover object-top"
                    />
                  </div>


                  <div className="text-center mt-2 text-sm font-semibold text-gray-800 flex-shrink-0">
                    {poloSectionTitle.label}
                  </div>
                </a>
              </div>
            )}

            {/* Product cards — 4 per row, filling columns 2–5 */}
            {poloProducts.map((product) => (
              <div key={product.id + '-' + product.name}>
                <a href={product.url} className="block group">
                  <div className="relative overflow-hidden rounded bg-gray-50">
                    <img
                      src={product.image}
                      alt={product.name}
                      loading="lazy"
                      className="w-full aspect-square object-cover group-hover:scale-105 transition-transform duration-300"
                    />

                    {/* Price tag — white bg, bottom center, inside image */}
                    <div className="absolute bottom-0 left-0 right-0 flex justify-center pb-1.5">
                      <div className="bg-white bg-opacity-95 rounded px-2 py-0.5 shadow-sm text-center leading-tight">
                        <strong className="text-gray-900 text-xs">৳ {product.price.toFixed(2)}</strong>{' '}
                        <s className="text-gray-400 text-[10px]">৳ {product.originalPrice.toFixed(2)}</s>
                      </div>
                    </div>

                    {product.viewMore && (
                      <div
                        onClick={(e) => { e.preventDefault(); window.location.href = product.viewMoreUrl; }}
                        className="absolute inset-0 flex flex-col items-center justify-center bg-black bg-opacity-40 text-white font-semibold text-sm gap-1 cursor-pointer"
                      >
                        <span>View</span>
                        <span>More</span>
                      </div>
                    )}
                  </div>
                  {/* No product name/title shown */}
                </a>
              </div>
            ))}

          </div>



          <div className="my-8 border-gray-300" />

          <div>
            <div className="flex flex-col lg:flex-row">
              <div className="w-full lg:w-2/3">
                <div>
                  <div className="flex items-center">
                    <span style={{ fontFamily: "'Assistant', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif", fontSize: '40px', color: '#373A3C' }}>
                      Fabrilife
                    </span>
                    <i style={{ color: '#5cb85c', fontSize: '40px' }} className="fa fa-angle-right" aria-hidden="true"></i>
                  </div>
                  <div style={{ fontSize: '24px', color: '#373A3C' }} className="mt-2">
                    Because comfort and confidence go hand in hand.
                  </div>
                  <p style={{ fontSize: '16px', color: '#373A3C' }} className="mt-2">
                    We focus on carefully selecting the best clothing that is comfortable, looks great, and makes you confident.
                    Apart from the fabric, design and fit, we go through strict quality control parameters to give you what you truly deserve.
                    The power of a good outfit is how it can influence your perception of yourself.
                  </p>
                </div>
              </div>
              <div className="w-full lg:w-1/3 mt-4 lg:mt-0">
                <a href="sdf">
                  <img src="https://fabrilife.com/image-gallery/638b1d9333f59.png" className="w-full h-auto" />
                </a>
              </div>
            </div>
          </div>
        </div>

      </main>

      {/* Chat Support Button */}
      <div className="fixed bottom-6 right-6 z-50">
        <button className="w-14 h-14 bg-blue-600 rounded-full flex items-center justify-center text-white shadow-lg hover:bg-blue-700 transition-colors">
          <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 28 32">
            <path d="M28,32 C28,32 23.2863266,30.1450667 19.4727818,28.6592 L3.43749107,28.6592 C1.53921989,28.6592 0,27.0272 0,25.0144 L0,3.6448 C0,1.632 1.53921989,0 3.43749107,0 L24.5615088,0 C26.45978,0 27.9989999,1.632 27.9989999,3.6448 L27.9989999,22.0490667 L28,22.0490667 L28,32 Z M23.8614088,20.0181333 C23.5309223,19.6105242 22.9540812,19.5633836 22.5692242,19.9125333 C22.5392199,19.9392 19.5537934,22.5941333 13.9989999,22.5941333 C8.51321617,22.5941333 5.48178311,19.9584 5.4277754,19.9104 C5.04295119,19.5629428 4.46760991,19.6105095 4.13759108,20.0170667 C3.97913051,20.2124916 3.9004494,20.4673395 3.91904357,20.7249415 C3.93763774,20.9825435 4.05196575,21.2215447 4.23660523,21.3888 C4.37862552,21.5168 7.77411059,24.5386667 13.9989999,24.5386667 C20.2248893,24.5386667 23.6203743,21.5168 23.7623946,21.3888 C23.9467342,21.2215726 24.0608642,20.9827905 24.0794539,20.7254507 C24.0980436,20.4681109 24.0195551,20.2135019 23.8614088,20.0181333 Z" />
          </svg>
        </button>
      </div>
    </div>
  );
}
